import type { FaireProductEntity } from "../../entity_types/product";

export const p_5mjycts4am: FaireProductEntity = {
  token: "p_5mjycts4am",
  type: "product",
  name: "Citrus Non-Alcoholic Kombucha",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/5b28c3fdfba2566254807807868bbdb49b4920f95c623f6cda90ef6f243d1b76.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e269e451dc52fa4e77dd8590fcf816dbb725f3553dad8608a2039f8c2e232ea.jpeg",
    "https://cdn.faire.com/fastly/2d3ad877d2c630702e8f75c23d650f0a1756b2920859328220a3f7cb3836672b.jpeg",
    "https://cdn.faire.com/fastly/85a858623a403a78c83e424606c0be7d8add9fcc86ac2d3896b4a77012291be3.png",
    "https://cdn.faire.com/fastly/fbac3a9826224696592e30aedb22e4e3aac0ee068f8a9c3b44b5837375df1077.jpeg",
    "https://cdn.faire.com/fastly/5f9a22ec21a08e6b99cf8b059f8278da808db485e47b7d60dca921397d568f39.jpeg",
    "https://cdn.faire.com/fastly/175ce415d21904ecae5cfc038582ebad4696e032007661e6eb7f61f4d88f3f24.png"
  ],
  priceDollars: 2.25,
  description: "A bright, tangy, and pleasantly carbonated craft non-alcoholic kombucha, flavored with organic grapefruit, lemon, and lime juices, and infused with muddled mint. \n\n***Please note: This item must be kept refrigerated.***\n\nWalker Brothers Citrus craft kombucha is non-alcoholic, unpasteurized and rich in live probiotics, gluten-free, kosher pareve, and vegan.\n\nIngredients: Raw Kombucha (Filtered Water, Kombucha Culture, Black Tea*, Green Tea*, Jasmine Tea*, Cane Sugar*), Grapefruit Juice*, Lemon Juice*, Lime Juice*, Apple Mint*\n*=certified organic ingredients\n\nPackaged in an aluminum can for ease of recycling \n\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:39.629Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
